/**
 * Centralized tooltip definitions for ConversationTree components
 */

export const CONVERSATION_TREE_TOOLTIPS = {
  // Entity Type tooltips
  ENTITY_TYPE_LABEL: "Choose the type of conversation participant: USER (customer messages), BOT (system responses), or DECISION (conditional logic branching)",
  
  // Node configuration tooltips
  POTENTIAL_START: "Mark this node as a potential entry point where conversations can begin, instead of always starting from the first node",
  IDENTIFIER: "Give this node a memorable name like 'welcome_message' or 'error_response'. This makes it easier to organize your conversation and reference it later. You can keep the random number or change it to something more descriptive.",
  DESTINATION_NODE: "Mark this as the end of a conversation path when no other nodes can follow.",
  CONTENT: "Use {variable_name} syntax to create placeholders that can be reused across nodes",
  TOOL_CALLS: "Enable this to add tool/function calls to this BOT response.",
  BOT_CONTENT_MODE: "Choose what this BOT node will do: show a text message (Content) or call a function/tool (Tool Calls). You can only choose one.",
  VARIABLE_ASSIGNMENT: "Assign values to decision variables when this node is reached. Variables control conversation flow logic.",
  OPTIONAL_FIELDS: "Advanced node settings including conversation flow controls (start/end nodes) and variable assignments for dynamic content.",
  
  // Node type specific tooltips
  USER_NODE: "Represents messages from customers/users in the conversation",
  BOT_NODE: "Represents system responses and bot messages",
  DECISION_NODE: "Represents conditional logic branching based on variables or conditions",
  
  // Action tooltips
  POTENTIAL_START_FLAG: "Potential Start Point",
  CLICK_TO_FOCUS: "Click to focus on this node",
  EDIT_VARIABLE: "Edit Variable",
  VARIABLE_IN_USE: "Variable is in use",
  DELETE_VARIABLE: "Delete Variable",
  EDIT_TOOL_CALL: "Edit this tool call (will update all nodes using it)",
  
  // Settings tooltips
  INTERJECTION_PROBABILITY: "Probability of interjection occurring during conversations",
  CUT_OFF_RESPONSE: "Cut off the bot response",
  CONCAT_QUESTION: "Concat question to the interjection response",
  PERSISTENT_VARIABLE: "When enabled, this variable will keep the same value throughout the entire conversation. When disabled, the value can change at different points in the conversation.",
  
  // Toolbar tooltips
  RESET_TREE: "Reset Conversation Tree",
  AUTO_ORGANIZE: "Auto-organize Layout",
  UNDO_ACTION: "Undo Last Action",
  CREATE_NEW_TREE: "Create New Tree",
  SAVE_TREE: "Save Conversation Tree",
  
  // Config panel
  OPEN_CONFIG_PANEL: "Open Config Panel",
} as const;

export type TooltipKey = keyof typeof CONVERSATION_TREE_TOOLTIPS;